const SELECTOR_TAB_BUTTON = '[role="tablist"] [data-tab-id]',
    SELECTOR_PANEL = '.tab-content [data-content-id]',
    CLASSNAME_ACTIVE = "active";
export default () => ({

    Tabs: [],
    Panels: [],
    ActiveTabToken: null,
    TabMap: new Map(),
    PanelMap: new Map(),

    updateActiveElements( token ) {
        if ( token === this.ActiveTabToken ) {
            return;
        }

        // console.log( { 'tab map': this.TabMap, 'current token': this.ActiveTabToken, 'tab element': this.TabMap.get( this.ActiveTabToken ) } );
        this.TabMap.get( this.ActiveTabToken ).classList.remove( CLASSNAME_ACTIVE );
        this.PanelMap.get( this.ActiveTabToken ).classList.remove( CLASSNAME_ACTIVE );

        this.ActiveTabToken = token;
        this.setActiveTabElements();
    },

    setActiveTabElements() {
        // console.log( { "this.TabMap": this.TabMap } );
        this.TabMap.get( this.ActiveTabToken ).classList.add( CLASSNAME_ACTIVE );
        this.PanelMap.get( this.ActiveTabToken ).classList.add( CLASSNAME_ACTIVE );
    },

    onClickTabElement( event ) {
        event.preventDefault();
        let trigger = event.target.closest( SELECTOR_TAB_BUTTON ),
            _token = trigger.getAttribute( "data-tab-id" );

        // console.log( "click", { event, "target": this.PanelMap.get( _token ) } );
        // console.log( "click", { event, "this": this } );
        this.updateActiveElements( _token );
    },

    init() {
        // console.log( 'Tabbed UI', { "this": this, "$root": this.$root } );

        this.Tabs = [ ... this.$root.querySelectorAll( SELECTOR_TAB_BUTTON ) ];
        this.Panels = [ ... this.$root.querySelectorAll( SELECTOR_PANEL ) ];

        // if there are no Tabs, there's no point. die quietly.
        if ( !this.Tabs.length ) { return; }

        // map the tabs/panels
        this.Tabs.forEach( function( element, index, array  ) {
            let token = element.getAttribute( 'data-tab-id' ),
            target;

            target = this.Panels.filter( function( panel ) {
                return panel.getAttribute( 'data-content-id' ) === token;
            }.bind( this ) )[ 0 ];

            // console.log({ token, target, index, element });

            if ( !!target ) {
                this.TabMap.set( token, element );
                this.PanelMap.set( token, target );

                element.addEventListener( "click", this.onClickTabElement.bind( this ) );

            } else {
                element.setAttribute( 'disabled', true );
            }

        }.bind( this ) );

        // any default 'active' tabs?
        this.ActiveTabToken = this.Tabs.filter( function( element ) {
            return element.classList.contains( CLASSNAME_ACTIVE );
        }.bind( this ) )[ 0 ]; // a disabled item might have active

        if ( !this.ActiveTabToken ) {
            this.ActiveTabToken = this.TabMap.keys().next().value;
            this.TabMap.get( this.ActiveTabToken ).setAttribute( 'data-tab-default', true );
        }

        this.setActiveTabElements();

        // console.log( 'tabs are mapped, active token is set', { 'active token': this.ActiveTabToken } );

    }
});
